import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenDetails } from '@app/core/models/token-detail.model';
@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  constructor(private http: HttpClient) {}
  /**
   * Get insight history data like daily active users, signup, failed logins
   */
  getActivityHistoryApi() {
    return this.http.get<TokenDetails>(`/insights/history`);
  }

  /**
   * Get total active users
   */
  getTotalActiveUsersApi() {
    return this.http.get<TokenDetails>(`/stats/active-users`);
  }

  /**
   * Get total clients, connections and resources.
   */
  getStatsOverviewApi(params) {
    return this.http.get<TokenDetails>(`/insights/overview`, { params: params });
  }
}
